module.exports = __webpack_public_path__ + "img/sierra-greer.4946015b.png";